import { render, staticRenderFns } from "./Collect.vue?vue&type=template&id=40622521&scoped=true&"
import script from "./Collect.vue?vue&type=script&lang=js&"
export * from "./Collect.vue?vue&type=script&lang=js&"
import style0 from "./Collect.vue?vue&type=style&index=0&id=40622521&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40622521",
  null
  
)

export default component.exports